import React from "react";
import style from "./companies.module.scss";
import Aside from "../../components/aside/aside.component";
import Footer from "../../components/footer/footer.component";
import Header from "../../components/header/header.component";

function CompaniesPage() {
  return (
    <div className="d-flex flex-column flex-root">
      <div className="page d-flex flex-row flex-column-fluid">
        <Aside />
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div
            className="content fs-6 d-flex flex-column flex-column-fluid"
            id="kt_content"
          >
            <div className="toolbar" id="kt_toolbar">
              <div className="container-fluid d-flex flex-stack flex-wrap flex-sm-nowrap">
                <div className="d-flex flex-column align-items-start justify-content-center flex-wrap me-2">
                  <h1 className="text-gray-900 fw-bold my-1 fs-2">
                    Empresas
                    <small className="text-muted fs-6 fw-normal ms-1" />
                  </h1>
                  <ul className="breadcrumb fw-semibold fs-base my-1">
                    <li className="breadcrumb-item text-muted">
                      Configuración
                    </li>
                    <li className="breadcrumb-item text-gray-900">Empresas</li>
                  </ul>
                </div>
                <div className="d-flex align-items-center flex-nowrap text-nowrap py-1">
                  <button className="btn btn-primary">
                    <i className="ki-duotone ki-plus"></i> Crear empresa
                  </button>
                </div>
              </div>
            </div>

            <div className="post fs-6 d-flex flex-column-fluid" id="kt_post">
              <div className="container-xxl">
                <div className="card">
                  <div className="card-header border-0 pt-6">
                    <div className="card-title">
                      <div className="d-flex align-items-center position-relative my-1">
                        <i className="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
                          <span className="path1" />
                          <span className="path2" />
                        </i>
                        <input
                          className="form-control form-control-solid w-250px ps-13"
                          placeholder="Buscar empresa"
                          type="text"
                        />
                      </div>
                    </div>
                    <div className="card-toolbar">
                      <div
                        className="d-flex justify-content-end"
                        data-kt-user-table-toolbar="base"
                      >
                        <button
                          className="btn btn-light-primary me-3"
                          data-kt-menu-placement="bottom-end"
                          data-kt-menu-trigger="click"
                          type="button"
                        >
                          <i className="ki-duotone ki-filter fs-2">
                            <span className="path1" />
                            <span className="path2" />
                          </i>
                          Filtro
                        </button>
                        <div
                          className="menu menu-sub menu-sub-dropdown w-300px w-md-325px"
                          data-kt-menu="true"
                        >
                          <div className="px-7 py-5">
                            <div className="fs-5 text-gray-900 fw-bold">
                              Filter Options
                            </div>
                          </div>
                          <div className="separator border-gray-200" />
                          <div
                            className="px-7 py-5"
                            data-kt-user-table-filter="form"
                          >
                            <div className="mb-10">
                              <label className="form-label fs-6 fw-semibold">
                                Role:
                              </label>
                              <select
                                aria-hidden="true"
                                className="form-select form-select-solid fw-bold select2-hidden-accessible"
                                data-allow-clear="true"
                                data-hide-search="true"
                                data-kt-initialized="1"
                                data-kt-select2="true"
                                data-kt-user-table-filter="role"
                                data-placeholder="Select option"
                                data-select2-id="select2-data-7-84hm"
                                tabIndex={-1}
                              >
                                <option data-select2-id="select2-data-9-qx9v" />
                                <option value="Administrator">
                                  Administrator
                                </option>
                                <option value="Analyst">Analyst</option>
                                <option value="Developer">Developer</option>
                                <option value="Support">Support</option>
                                <option value="Trial">Trial</option>
                              </select>
                              <span
                                className="select2 select2-container select2-container--bootstrap5"
                                data-select2-id="select2-data-8-v513"
                                dir="ltr"
                                style={{
                                  width: "100%",
                                }}
                              >
                                <span className="selection">
                                  <span
                                    aria-controls="select2-e7md-container"
                                    aria-disabled="false"
                                    aria-expanded="false"
                                    aria-haspopup="true"
                                    aria-labelledby="select2-e7md-container"
                                    className="select2-selection select2-selection--single form-select form-select-solid fw-bold"
                                    role="combobox"
                                    tabIndex={0}
                                  >
                                    <span
                                      aria-readonly="true"
                                      className="select2-selection__rendered"
                                      id="select2-e7md-container"
                                      role="textbox"
                                      title="Select option"
                                    >
                                      <span className="select2-selection__placeholder">
                                        Select option
                                      </span>
                                    </span>
                                    <span
                                      className="select2-selection__arrow"
                                      role="presentation"
                                    >
                                      <b role="presentation" />
                                    </span>
                                  </span>
                                </span>
                                <span
                                  aria-hidden="true"
                                  className="dropdown-wrapper"
                                />
                              </span>
                            </div>
                            <div className="mb-10">
                              <label className="form-label fs-6 fw-semibold">
                                Two Step Verification:
                              </label>
                              <select
                                aria-hidden="true"
                                className="form-select form-select-solid fw-bold select2-hidden-accessible"
                                data-allow-clear="true"
                                data-hide-search="true"
                                data-kt-initialized="1"
                                data-kt-select2="true"
                                data-kt-user-table-filter="two-step"
                                data-placeholder="Select option"
                                data-select2-id="select2-data-10-ij3q"
                                tabIndex={-1}
                              >
                                <option data-select2-id="select2-data-12-89bk" />
                                <option value="Enabled">Enabled</option>
                              </select>
                              <span
                                className="select2 select2-container select2-container--bootstrap5"
                                data-select2-id="select2-data-11-5c4h"
                                dir="ltr"
                                style={{
                                  width: "100%",
                                }}
                              >
                                <span className="selection">
                                  <span
                                    aria-controls="select2-ymrv-container"
                                    aria-disabled="false"
                                    aria-expanded="false"
                                    aria-haspopup="true"
                                    aria-labelledby="select2-ymrv-container"
                                    className="select2-selection select2-selection--single form-select form-select-solid fw-bold"
                                    role="combobox"
                                    tabIndex={0}
                                  >
                                    <span
                                      aria-readonly="true"
                                      className="select2-selection__rendered"
                                      id="select2-ymrv-container"
                                      role="textbox"
                                      title="Select option"
                                    >
                                      <span className="select2-selection__placeholder">
                                        Select option
                                      </span>
                                    </span>
                                    <span
                                      className="select2-selection__arrow"
                                      role="presentation"
                                    >
                                      <b role="presentation" />
                                    </span>
                                  </span>
                                </span>
                                <span
                                  aria-hidden="true"
                                  className="dropdown-wrapper"
                                />
                              </span>
                            </div>
                            <div className="d-flex justify-content-end">
                              <button
                                className="btn btn-light btn-active-light-primary fw-semibold me-2 px-6"
                                data-kt-menu-dismiss="true"
                                data-kt-user-table-filter="reset"
                                type="reset"
                              >
                                Reset
                              </button>
                              <button
                                className="btn btn-primary fw-semibold px-6"
                                data-kt-menu-dismiss="true"
                                data-kt-user-table-filter="filter"
                                type="submit"
                              >
                                Apply
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body py-4">
                    <div
                      className="dt-container dt-bootstrap5 dt-empty-footer"
                      id="kt_table_users_wrapper"
                    >
                      <div className="table-responsive" id="">
                        <table
                          className="table align-middle table-row-dashed fs-6 gy-5 dataTable"
                          id="kt_table_users"
                        >
                          <thead>
                            <tr
                              className="text-start text-muted fw-bold fs-7 text-uppercase gs-0"
                              role="row"
                            >
                              <th
                                className="min-w-125px "
                                colSpan={1}
                                rowSpan={1}
                                tabIndex={0}
                              >
                                <span className="" >
                                  ID
                                </span>
                                <span className="dt-column-order" />
                              </th>
                              <th
                                aria-label="Role: Activate to sort"
                                className="min-w-125px "
                                colSpan={1}
                                rowSpan={1}
                                tabIndex={0}
                              >
                                <span className="" >
                                  Nombre
                                </span>
                                <span className="dt-column-order" />
                              </th>
                              <th
                                aria-label="Last login: Activate to sort"
                                className="min-w-125px "
                                colSpan={1}
                                rowSpan={1}
                                tabIndex={0}
                              >
                                <span className="" >
                                  Estatus
                                </span>
                                <span className="dt-column-order" />
                              </th>
                              <th
                                aria-label="Joined Date: Activate to sort"
                                className="min-w-125px "
                                colSpan={1}
                                rowSpan={1}
                                tabIndex={0}
                              >
                                <span className="" >
                                  Fecha de creación
                                </span>
                                <span className="dt-column-order" />
                              </th>
                              <th
                                aria-label="Actions"
                                className="text-end min-w-100px dt-orderable-none"
                                colSpan={1}
                                rowSpan={1}
                              >
                                <span className="">
                                  Acciones
                                </span>
                                <span className="dt-column-order" />
                              </th>
                            </tr>
                          </thead>
                          <tbody className="text-gray-600 fw-semibold">
                            <tr>
                              <td>123456789abcdfe</td>
                              <td>
                                <p className="text-gray-800 m-0">Empresa 1</p>
                              </td>
                              <td>
                                <div className="badge badge-success fw-bold">
                                  Activo
                                </div>
                              </td>
                              <td>01 de julio 2024, 12:34:59</td>
                              <td className="text-end">
                                <button
                                  className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm"
                                  data-kt-menu-placement="bottom-end"
                                  data-kt-menu-trigger="click"
                                >
                                  Acciones
                                  <i className="ki-duotone ki-down fs-5 ms-1" />
                                </button>
                                <div
                                  className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4"
                                  data-kt-menu="true"
                                >
                                  <div className="menu-item px-3">
                                    <a
                                      className="menu-link px-3"
                                      href="apps/user-management/users/view.html"
                                    >
                                      Edit
                                    </a>
                                  </div>
                                  <div className="menu-item px-3">
                                    <a
                                      className="menu-link px-3"
                                      data-kt-users-table-filter="delete_row"
                                      href="#"
                                    >
                                      Delete
                                    </a>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot />
                        </table>
                      </div>
                      <div className="row" id="">
                        <div
                          className="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start dt-toolbar"
                          id=""
                        />
                        <div
                          className="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end"
                          id=""
                        >
                          <div className="dt-paging paging_simple_numbers">
                            <ul className="pagination">
                              <li className="dt-paging-button page-item disabled">
                                <a
                                  aria-controls="kt_table_users"
                                  aria-disabled="true"
                                  aria-label="Previous"
                                  className="page-link previous"
                                  data-dt-idx="previous"
                                  tabIndex={-1}
                                >
                                  <i className="previous" />
                                </a>
                              </li>
                              <li className="dt-paging-button page-item active">
                                <a
                                  aria-controls="kt_table_users"
                                  aria-current="page"
                                  className="page-link"
                                  data-dt-idx="0"
                                  href="#"
                                  tabIndex={0}
                                >
                                  1
                                </a>
                              </li>
                              <li className="dt-paging-button page-item">
                                <a
                                  aria-controls="kt_table_users"
                                  className="page-link"
                                  data-dt-idx="1"
                                  href="#"
                                  tabIndex={0}
                                >
                                  2
                                </a>
                              </li>
                              <li className="dt-paging-button page-item">
                                <a
                                  aria-controls="kt_table_users"
                                  className="page-link"
                                  data-dt-idx="2"
                                  href="#"
                                  tabIndex={0}
                                >
                                  3
                                </a>
                              </li>
                              <li className="dt-paging-button page-item">
                                <a
                                  aria-controls="kt_table_users"
                                  aria-label="Next"
                                  className="page-link next"
                                  data-dt-idx="next"
                                  href="#"
                                  tabIndex={0}
                                >
                                  <i className="next" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default CompaniesPage;
